module.exports = __webpack_public_path__ + "media/icons/link-website@3x-3576d99d.svg";